import { createFileRoute } from "@tanstack/react-router";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { absoluteUrl } from "@/lib/site";
import { canonicalLink, hreflangLinks } from "@/lib/seo";

export const Route = createFileRoute("/impressum")({
  head: () => ({
    meta: [
      { title: "Impressum – Smartlane GmbH" },
      {
        name: "description",
        content: "Impressum und rechtliche Angaben gemäß § 5 DDG der Smartlane GmbH, München.",
      },
      { name: "robots", content: "noindex, follow" },
      { property: "og:title", content: "Impressum – Smartlane GmbH" },
      {
        property: "og:description",
        content: "Impressum und rechtliche Angaben gemäß § 5 DDG der Smartlane GmbH, München.",
      },
      { property: "og:url", content: absoluteUrl("/impressum") },
      { property: "og:type", content: "website" },
    ],
    links: [canonicalLink("/impressum"), ...hreflangLinks("/impressum")],
  }),
  component: ImpressumPage,
});

function ImpressumPage() {
  return (
    <>
      <Navigation />

      <section className="bg-white pt-32 md:pt-40 pb-24">
        <div className="mx-auto max-w-4xl px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="font-heading text-4xl md:text-6xl uppercase tracking-wider text-rich-black mb-12">
              Impressum
            </h1>

            <div className="space-y-8 font-body text-base text-rich-black/80 leading-relaxed">
              <div>
                <h2 className="font-heading text-2xl uppercase tracking-wider text-rich-black mb-3">
                  Angaben gemäß § 5 DDG
                </h2>
                <p>Smartlane GmbH</p>
                <p>Gotzinger Straße 8</p>
                <p>81371 München</p>
                <p className="mt-3">Handelsregister: HRB 220483</p>
                <p>Registergericht: München</p>
                <p className="mt-3">
                  <strong className="text-rich-black">Vertreten durch:</strong>
                </p>
                <p>Monja Mühling, Florian Schimandl</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl uppercase tracking-wider text-rich-black mb-3">
                  Kontakt
                </h2>
                <p>
                  E-Mail:{" "}
                  <a
                    href="mailto:info@smartlane.ai"
                    className="text-smartlane-orange hover:underline"
                  >
                    info@smartlane.ai
                  </a>
                </p>
              </div>

              <div>
                <h2 className="font-heading text-2xl uppercase tracking-wider text-rich-black mb-3">
                  Umsatzsteuer-ID
                </h2>
                <p>
                  Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
                  DE301856148
                </p>
              </div>

              <div>
                <h2 className="font-heading text-2xl uppercase tracking-wider text-rich-black mb-3">
                  Verbraucherstreitbeilegung / Universalschlichtungsstelle
                </h2>
                <p>
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
                  vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
